import React, { useEffect, useRef, useState } from 'react';
import { copyText } from '../utils/clipboard';
import './CopyButton.css';

/**
 * Кнопка «Копировать» без всплывающих окон: после нажатия на 2 секунды показывает «✓ Скопировано».
 * Если браузер не дал скопировать — выделяет текст в соседнем поле и подсказывает нажать Ctrl+C.
 */
function CopyButton({ text, label = 'Копировать', copiedLabel = 'Скопировано', className = 'pc-btn', ...rest }) {
    const [state, setState] = useState('idle'); // idle | copied | failed
    const timer = useRef(null);
    useEffect(() => () => clearTimeout(timer.current), []);

    const onClick = async (e) => {
        const button = e.currentTarget;
        const ok = await copyText(text);
        if (!ok) {
            const field = button.parentElement?.querySelector('input, textarea');
            if (field) {
                field.focus();
                field.select();
            }
        }
        setState(ok ? 'copied' : 'failed');
        clearTimeout(timer.current);
        timer.current = setTimeout(() => setState('idle'), ok ? 2000 : 4000);
    };

    return (
        <button
            type="button"
            className={`${className} copy-btn${state !== 'idle' ? ` copy-btn--${state}` : ''}`}
            onClick={onClick}
            aria-live="polite"
            {...rest}
        >
            {state === 'copied' && `✓ ${copiedLabel}`}
            {state === 'failed' && 'Выделено — нажмите Ctrl+C'}
            {state === 'idle' && label}
        </button>
    );
}

export default CopyButton;
